// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guest-submission-container {
  margin-top: 1rem;
}
.guest-submission-container ul li {
  margin-top: 0.8rem;
}
.guest-submission-container ul li i:before {
  margin-right: 10px;
}
.guest-submission-container p {
  padding-block: 1rem;
  word-wrap: break-word;
}
.guest-submission-container p:not(:last-of-type) {
  margin: 0 0 1rem 0 !important;
}
.lsn-page-success h1 {
  margin-top: 1rem;
}
.lsn-page-success ul {
  margin-block: 0;
}
.lsn-page-success ul li:not(:last-child) {
  margin: 0 0 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/success/extras.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAFA;EAII,kBAAA;AACJ;AALA;EAOM,kBAAA;AACN;AARA;EAYI,mBAAA;EACA,qBAAA;AADJ;AAGI;EACE,6BAAA;AADN;AAMA;EAEI,gBAAA;AALJ;AAGA;EAMI,eAAA;AANJ;AAAA;EASM,kBAAA;AANN","sourcesContent":[".guest-submission-container {\n  margin-top: 1rem;\n\n  ul li {\n    margin-top: .8rem;\n\n    i:before {\n      margin-right: 10px;\n    }\n  }\n\n  p {\n    padding-block: 1rem;\n    word-wrap: break-word;\n\n    &:not(:last-of-type) {\n      margin: 0 0 1rem 0 !important;\n    }\n  }\n}\n\n.lsn-page-success {\n  h1 {\n    margin-top: 1rem;\n  }\n\n  ul {\n    margin-block: 0;\n\n    li:not(:last-child) {\n      margin: 0 0 0.8rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
